/**
 * File related-links-ajax.js.
 * Handles logic for the related links ajax
 */

document.addEventListener("DOMContentLoaded", function() {

  function handleAjaxSuccess(response) {
    document.querySelector('.blog-related-links').innerHTML = response;
  }

  function handleAjaxError(error) {
    console.error('Error fetching related links:', error);
  }

  const ajaxArgs = {
    url: ajaxlinks?.ajaxurl,
    data: {
      action: 'related_links',
      pid: ajaxlinks?.pid,
    },
    successFunc: handleAjaxSuccess,
    errorFunc: handleAjaxError,
  };

  sendAjaxPost(ajaxArgs);
});